import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the deposit report view.
 * @extends JetView
 */
export default class tableDepositReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Get current user parameter

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 450 : 0, // Conditional height based on screen width
                            columns: [
                                // Column definitions for the datatable
                                {
                                    id: 'Action', // Column ID
                                    header: '', // Column header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Acción'), // Tooltip for the column
                                    hidden: !devConfig.getPermAction(
                                        // Conditional visibility based on permissions
                                        'torefuseTransactionBetShop',
                                        'Torefuse',
                                    ),
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        if (obj.AllowCancelTransaction == true) {
                                            // Check if transaction can be canceled
                                            if (devConfig.getPermAction('torefuseTransactionBetShop', 'Torefuse')) {
                                                return "<span class='webix_icon wxi-close torefuse prm-torefuseTransactionBetShop'></span>"; // Return icon for cancel action
                                            }
                                        }
                                        return ''; // Return empty string if conditions are not met
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('Id'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                    hidden: true, // Hidden column
                                },
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha'), // Column header
                                    fillspace: 0, // Fill space setting
                                    minWidth: 0, // Minimum width
                                    width: 200, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'Hour', // Column ID
                                    header: _('Hora'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'NoTicket', // Column ID
                                    header: _('No. Ticket'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'FormaPago1', // Column ID
                                    header: _('Forma Pago 1'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PagoBonoTC', // Column ID
                                    header: _('Pago Bono / T.C.'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorEntradasEfectivo', // Column ID
                                    header: _('Valor Entradas Efectivo'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DevolucionRecargas', // Column ID
                                    header: _('Recargas Anuladas'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorEntradasBonoTC', // Column ID
                                    header: _('Valor Entradas Bono / T.C.'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorEntradasTraslados', // Column ID
                                    header: _('Valor Entradas Traslados'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorEntradasRecargas', // Column ID
                                    header: _('Valor Entradas Recargas'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorEntradasRecargasAgentes', // Column ID
                                    header: _('Valor Entradas Recargas Agentes'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorSalidasEfectivo', // Column ID
                                    header: _('Valor Salidas Efectivo'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorSalidasTraslados', // Column ID
                                    header: _('Valor Salidas Traslados'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ValorSalidasNotasRetiro', // Column ID
                                    header: _('Valor Salidas Notas de Retiro'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Saldo', // Column ID
                                    header: _('Saldo'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Moneda', // Column ID
                                    header: _('Moneda'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                torefuse: function (euv, id) {
                                    // Function to handle cancel action
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        // Confirmation dialog for cancel action
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea cancelar transacción?'),
                                        ok: _('Aceptar'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            // Callback for confirmation dialog
                                            if (action === true) {
                                                // If confirmed
                                                var item = vvthis.getItem(id); // Get the item from the datatable
                                                if (item.AllowCancelTransaction) {
                                                    // Check if transaction can be canceled
                                                    webix
                                                        .ajax() // AJAX request to cancel the transaction
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'es/Financial/CancelTransaction',
                                                            '{ "Id":' + item.Id + '}',
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    // Error handler
                                                                    webix.message(_('Error! ')); // Show error message
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    // Success handler
                                                                    item.AllowCancelTransaction = false; // Update item state
                                                                    webix.message(_('Transacción cancelada')); // Show success message
                                                                    vvthis.$$('datatable').refresh(); // Refresh the datatable
                                                                },
                                                            },
                                                        );
                                                } else {
                                                    webix.message({
                                                        // Show alert if transaction cannot be canceled
                                                        text: _('Esta transacción no permite ser cancelada'),
                                                        title: _('¡Error!'),
                                                        type: 'alert-error',
                                                    });
                                                }
                                            }
                                        },
                                    });
                                },
                            },
                            footer: true, // Enable footer
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead setting
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch setting
                            pager: 'pagerA', // Pager ID
                            leftSplit: screen.width > 500 && screen.height > 500 ? 1 : 0, // Conditional left split based on screen size
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'es/Financial/GetFlujoCaja?FromId=' + cur_user + '&'; // API URL for fetching data
        var filter = ''; // Initialize filter string

        // Event listener for filtering data
        this.on(this.app, 'flujoCaja:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check if value is not an object and not empty
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check if value is not null
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Append current user to query string
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            $$('filterPopup').hide(); // Hide filter popup
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id); // Load data based on selected player
        });
    }
}

// FILE DOCUMENTED
